import { TextAreaAttributeProps } from 'Types/Attribute.types'
import { Input } from 'antd/lib'
import React, { useCallback } from 'react'
import './TextArea.less'

const { TextArea } = Input

const TextAreaAttribute: React.FC<TextAreaAttributeProps> = props => {
    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            props.onChange(e.target.value || undefined)
        },
        [props]
    )

    return (
        <div
            className={`attribute-main ${props.className}`}
            style={{ width: props.width ?? '90%' }}
            data-testid="textarea-wrapper"
        >
            <span className="attribute-main-title">{props.label}</span>
            <TextArea
                showCount={props.showCount}
                maxLength={props.maxLength}
                onChange={handleChange}
                placeholder={props.placeholder ?? 'Add Comments'}
                value={props.value}
                rows={props.rows}
                allowClear={props.allowClear}
                disabled={props.readonly}
            />
        </div>
    )
}

export default TextAreaAttribute
